import { Box, FormControl, FormLabel, Option, Select, Tab, TabList, Tabs } from '@mui/joy';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

export interface SectionOption { value: string; label: string; to: string }

/** Full section names stay available without pushing mobile content below the fold. */
export function SectionNavigation({ label, value, options }: {
  label: string; value: string; options: SectionOption[];
}) {
  const navigate = useNavigate();
  const selected = options.some(option => option.value === value) ? value : null;
  return <Box component="nav" aria-label={label} sx={{ mb: 3 }}>
    <FormControl sx={{ display: { xs: 'flex', md: 'none' } }}>
      <FormLabel>{label}</FormLabel>
      <Select value={selected} placeholder="Choose a section" onChange={(_, next) => {
        const option = options.find(item => item.value === next);
        if (option) navigate(option.to);
      }}>
        {options.map(option => <Option key={option.value} value={option.value}>{option.label}</Option>)}
      </Select>
    </FormControl>
    <Tabs value={selected} sx={{ display: { xs: 'none', md: 'block' } }}>
      <TabList aria-label={label} sx={{ flexWrap: 'wrap' }}>
        {options.map(option => <Tab key={option.value} value={option.value} component={RouterLink} to={option.to}>{option.label}</Tab>)}
      </TabList>
    </Tabs>
  </Box>;
}
